import LegalDoc from '../../components/LegalDoc';
import markdown from '../../content/legal/b2b-business-terms.md?raw';

export default function B2BTermsScreen() {
  return <LegalDoc markdown={markdown} title="Business Terms of Service" />;
}
